export const INITIALIZE_NEW_BUSINESS_PROFILE = 'initialize-new-business-profile';
const initializeNewBusinessProfile = () => ({ type: INITIALIZE_NEW_BUSINESS_PROFILE });
export default initializeNewBusinessProfile;
